//region :: Imports ::
import MNSwagClientBase from '../Toolkit/Api/NSwagClientBase';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import axios, {AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken} from 'axios';

//endregion

/** */
export abstract class TrafficManagementClientBase extends MNSwagClientBase<MNSwagClientConfiguration> {

    /** */
    protected constructor(configuration: MNSwagClientConfiguration) {
        super(configuration);

    }

    /** */
    protected override onGetBaseUrl(baseUrl?: string): string {
        return process.env.REACT_APP_TRAFFICMANAGEMENT_API!;
    }

    /** */
    protected override onTransformOptions(requestOptions: any): Promise<any> {
        return Promise.resolve(requestOptions);
    }

}

export class Filter implements IFilter {
    property: string | undefined;
    operation: string | undefined;
    constant: string | number | undefined;

    constructor(data?: IFilter) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property)) {
                    (this as any)[property] = (data as any)[property];
                }
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.property = _data['property'];
            this.operation = _data['operation'];
            this.constant = _data['constant'];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['property'] = this.property;
        data['operation'] = this.operation;
        data['constant'] = this.constant;
        return data;
    }
};

export interface IFilter {
    property: string | undefined;
    operation: string | undefined;
    constant: string | number | undefined;
};

export class EnvironmentClient extends TrafficManagementClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    get(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
